exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "textarea[data-v-6a3d13e6]{border-radius:0!important}", ""]);

// exports
